/**
 * Non-wire shapes for the brist ("sim flaw") views. The brist rows and the
 * aggregates themselves live in `@homepal/api-contract` and are aliased in
 * `redux/selectors/internal/SimFlaws`.
 */
import { TSimFlawType } from 'redux/api/internal/SimFlaws/contract'

export type { TSimFlawSettingDto as SettingRow } from 'redux/api/internal/SimFlaws/contract'

/**
 * The wire type as an enum, so the `Typ` filter can iterate the types and
 * `translateEnum('flaw_types', …)` can label them. `flawTypeColor` below is
 * keyed by the wire union, so adding a type to the contract fails to compile
 * here until this enum grows with it.
 */
export enum FlawType {
  DUPLICATE = 'DUPLICATE',
  IS_NULL = 'IS_NULL'
}

export const flawTypeColor: { [type in TSimFlawType]: 'warning' | 'error' } = {
  [FlawType.DUPLICATE]: 'error',
  [FlawType.IS_NULL]: 'warning'
}

/**
 * The wire value as the enum member, for the APIs typed on the enum -
 * `translateEnum('flaw_types', …)` above all. Safe because the enum's keys and
 * values are the same strings, which the `flawTypeColor` mapping enforces.
 */
export function asFlawType(type: TSimFlawType): FlawType {
  return FlawType[type]
}
